<form [formGroup]="indentForm" (ngSubmit)="onSubmit()">
  <div class="card shadow-sm">
    <div class="card-body bg-light">
      <div class="mb-3 d-flex gap-2 align-items-center">
        <button type="button" class="btn btn-secondary" (click)="openFilter()">Filter</button>
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>

      @if (stores?.length === 0) {
        <div class="text-muted">
          No store products to display. Click <b>Filter</b> and apply to load store-wise products.
        </div>
      }

      <div formArrayName="stores">
        @for (_store of stores.controls; track _store; let si = $index) {
          <div [formGroupName]="si" class="mb-4">
            <div class="card">
              <div class="card-header d-flex justify-content-between align-items-center">
                <div>
                  <strong>{{ indentForm.get(['stores', si, 'storeName'])?.value || indentForm.get(['stores', si, 'storeId'])?.value }}</strong>
                </div>
              </div>
              <div class="card-body p-2">
                <div class="table-responsive">
                  <table class="table table-sm mb-0">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Product</th>
                        <th>UOM</th>
                        <th class="text-end">MRP</th>
                        <th class="text-end">Price</th>
                        <th style="width:120px">Qty</th>
                      </tr>
                    </thead>
                    <tbody formArrayName="items">
                      @for (_item of getItems(si).controls; track _item; let ii = $index) {
                        <tr [formGroupName]="ii">
                          <td>{{ indentForm.get(['stores', si, 'items', ii, 'sku'])?.value }}</td>
                          <td>{{ indentForm.get(['stores', si, 'items', ii, 'name'])?.value }}</td>
                          <td>{{ indentForm.get(['stores', si, 'items', ii, 'uom'])?.value }}</td>
                          <td class="text-end">{{ indentForm.get(['stores', si, 'items', ii, 'mrp'])?.value }}</td>
                          <td class="text-end">{{ indentForm.get(['stores', si, 'items', ii, 'sellingPrice'])?.value }}</td>
                          <td>
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              formControlName="qty"
                              min="0"
                              />
                            @if (indentForm.get(['stores', si, 'items', ii, 'qty'])?.invalid && (indentForm.get(['stores', si, 'items', ii, 'qty'])?.touched || indentForm.get(['stores', si, 'items', ii, 'qty'])?.dirty)) {
                              <div class="text-danger small mt-1">
                                Qty required &ge; 0
                              </div>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

    </div>
  </div>
</form>
